module.exports = require('../impls/wrap-values/wrap-values.js').wrapValues;